import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import SharedReading from "./pages/SharedReading";

function App() {
  return (
    <>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/r/:id" element={<SharedReading />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
